import { t } from '@transifex/native';

import { flashes } from 'pkg/actions';
import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import { create as modelsCreate } from 'pkg/api/models/actions';
import * as sdk from 'pkg/core/sdk';

export interface CreateOpponentPlayerPayload {
	groupID: number;
	userID: number;
	firstName: string;
	lastName?: string;
	profileImageAttachmentID?: number;
	opponentClubID?: number;
}

export interface UpdateOpponentPlayerPayload {
	firstName: string;
	lastName?: string;
	profileImageAttachmentID?: number;
	opponentClubID?: number;
}

export const create = async (
	organizationID: number,
	payload: CreateOpponentPlayerPayload
): Promise<[Response, models.opponentPlayer.OpponentPlayer]> => {
	const [request, response] = await modelsCreate<
		CreateOpponentPlayerPayload,
		models.opponentPlayer.OpponentPlayer
	>(endpoints.Opponents.CreatePlayer(organizationID), payload);

	if (!request.ok) {
		flashes.show({
			title: t('Something went wrong!'),
			message: t(
				`If you think this error isn't supposed to happen, please contact 360Player support.`
			),
		});
		return [request, null];
	}

	return [request, response];
};

export const remove = async (
	organizationID: number,
	opponentPlayerID: number
): Promise<[Response, models.opponentPlayer.OpponentPlayer]> => {
	const request = await sdk.destroy(
		endpoints.Opponents.DeletePlayer(organizationID, opponentPlayerID),
		{}
	);

	const response = await request.json();

	if (!request.ok) {
		flashes.show(
			{
				title: t('Something went wrong!'),
				message: response.error,
			},
			request.status
		);
		return [request, null];
	}

	return [request, response];
};

export const update = async (
	organizationID: number,
	opponentPlayerID: number,
	payload: UpdateOpponentPlayerPayload
): Promise<[Response, models.opponentPlayer.OpponentPlayer]> => {
	const request = await sdk.patch(
		endpoints.Opponents.UpdatePlayer(organizationID, opponentPlayerID),
		{},
		payload
	);

	if (!request.ok) {
		flashes.show({
			title: t('Something went wrong!'),
			message: t(
				`If you think this error isn't supposed to happen, please contact 360Player support.`
			),
		});
		return [request, null];
	}

	const response = await request.json();

	return [request, response];
};
